import { UPDATE_USERS_TO_ACTIVE_ERROR, UPDATE_USERS_TO_ACTIVE_SUCCESS } from "../actions/types";

export default (state = { error: "", success: "", isSwitchSnackbarOn: false }, action) => {
    switch (action.type) {
        case UPDATE_USERS_TO_ACTIVE_ERROR:
            return {
                ...state,
                error: action.payload,
                success: state.success,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'User activate fail',
                key: action.key,
            };
        case UPDATE_USERS_TO_ACTIVE_SUCCESS:
            return {
                ...state,
                error: state.error,
                success: action.payload,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'User activate successful',
                key: action.key,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/updateUsersToActiveReducer.js